<template>
  <div>
    {{ displayText }}
    <button
      v-if="shouldTruncate"
      class="stk-reset show-more"
      @click.stop.prevent="handleToggle"
    >
      {{ isExpanded ? "Show less" : "Show more" }}
    </button>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
  text: {
    type: String,
    required: true,
  },
  length: {
    type: Number,
    default: 120,
  },
});

const isExpanded = ref(false);

const shouldTruncate = computed(() => props.text.length > props.length);

const displayText = computed(() => {
  if (isExpanded.value || !shouldTruncate.value) {
    return props.text;
  } else {
    return props.text.slice(0, props.length - 20) + '…';
  }
});

function handleToggle() {
  isExpanded.value = !isExpanded.value;
}
</script>

<style scoped>
.show-more {
  color: var(--stk-primary);
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}
</style>
